export const GET_LIST_DANHSACHTAISAN = "GET_LIST_DANHSACHTAISAN";
export const GET_LIST_DANHSACHTAISAN_SUCCESS =
  "GET_LIST_DANHSACHTAISAN_SUCCESS";
export const GET_LIST_DANHSACHTAISAN_FAILURE =
  "GET_LIST_DANHSACHTAISAN_FAILURE";
export const GET_LIST_TAISAN = "GET_LIST_TAISAN";
export const GET_LIST_TAISAN_SUCCESS = "GET_LIST_TAISAN_SUCCESS";
export const GET_LIST_TAISAN_FAILURE = "GET_LIST_TAISAN_FAILURE";

export const UPDATE_SEARCHTDATA_TAISAN = "UPDATE_SEARCHTDATA_TAISAN";
